import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { BRAND_TYPE } from "@faire/help-center-utils/consts/BRAND_TYPE";
import { RETAILER_TYPE } from "@faire/help-center-utils/consts/RETAILER_TYPE";
import { getBrand } from "@faire/help-center-utils/serialized-data/getBrand";
import { getRetailer } from "@faire/help-center-utils/serialized-data/getRetailer";
import { ICreateTicketRequest } from "@faire/web-api/com/faire/vendor/zendesk/ICreateTicketRequest";
import { ZendeskViaChannelId } from "@faire/web-api/com/faire/vendor/zendesk/ZendeskViaChannelId";
import { ISO3166Alpha3 } from "@faire/web-api/indigofair/iso3166/ISO3166Alpha3";
import UAParser from "ua-parser-js";
import { getAllZenDeskTagsInArray } from "../../utils/zenDeskTags";
export var getCallRequestTicketPayload = function getCallRequestTicketPayload(_ref) {
  var _ua$browser$name, _ua$os$name, _ua$os$version, _ua$browser$version, _retailer$name, _ref2, _retailer$country;
  var values = _ref.values,
    issueType = _ref.issueType;
  var retailer = getRetailer();
  var brand = getBrand();
  var ua = new UAParser(navigator.userAgent).getResult();
  var platform = (_ua$browser$name = ua.browser.name) !== null && _ua$browser$name !== void 0 ? _ua$browser$name : "";
  var osVersion = "".concat((_ua$os$name = ua.os.name) !== null && _ua$os$name !== void 0 ? _ua$os$name : "", " ").concat((_ua$os$version = ua.os.version) !== null && _ua$os$version !== void 0 ? _ua$os$version : "");
  var appVersion = (_ua$browser$version = ua.browser.version) !== null && _ua$browser$version !== void 0 ? _ua$browser$version : "";
  var customerType = retailer ? RETAILER_TYPE : BRAND_TYPE;
  var businessName = (_retailer$name = retailer === null || retailer === void 0 ? void 0 : retailer.name) !== null && _retailer$name !== void 0 ? _retailer$name : brand === null || brand === void 0 ? void 0 : brand.name;
  var customerBasedIn = (_ref2 = (_retailer$country = retailer === null || retailer === void 0 ? void 0 : retailer.country) !== null && _retailer$country !== void 0 ? _retailer$country : brand === null || brand === void 0 ? void 0 : brand.based_in) !== null && _ref2 !== void 0 ? _ref2 : ISO3166Alpha3.USA;
  var phone_number = values.phone;
  var fallbackIssueType = issueType === "" ? "Phone Ticket" : "Issue type: ".concat(issueType);
  var description = values.details === "" ? fallbackIssueType : "".concat(values.details, " - ").concat(fallbackIssueType);
  var phoneTicketPayload = ICreateTicketRequest.build({
    tags: getAllZenDeskTagsInArray(customerBasedIn !== null && customerBasedIn !== void 0 ? customerBasedIn : "", customerType !== null && customerType !== void 0 ? customerType : "", issueType !== null && issueType !== void 0 ? issueType : "", "phone"),
    email: values.email,
    user_name: values.name,
    name: businessName,
    phone_number: phone_number,
    brand_order_token: values.brandOrderNumber,
    issue_type: issueType,
    description: description,
    platform: platform,
    os_version: osVersion,
    app_version: appVersion,
    via_channel_id: ZendeskViaChannelId.PHONE_CALL_INBOUND,
    order_token: values.orderToken
  });
  return {
    phoneTicketPayload: phoneTicketPayload
  };
};